module.exports = __webpack_public_path__ + "img/gold_frame.495ac0d0.png";